/* Custom Featured Product — gallery swap + nutrition modal. */
(function () {
  // ---------- Gallery ----------
  if (!customElements.get('custom-product-gallery')) {
    class CustomProductGallery extends HTMLElement {
      connectedCallback() {
        this.mainContainer = this.querySelector('.cfp__main');
        this.track = this.querySelector('[data-track]');
        this.slides = Array.from(this.querySelectorAll('.cfp__main-slide'));
        this.thumbs = Array.from(this.querySelectorAll('.cfp__thumb'));
        this.prevBtn = this.querySelector('[data-prev]');
        this.nextBtn = this.querySelector('[data-next]');
        this.index = 0;
        this.width = 0;
        if (this.slides.length === 0 || !this.track) return;

        this.thumbs.forEach((thumb) => {
          thumb.addEventListener('click', () => {
            const i = parseInt(thumb.dataset.thumb, 10);
            if (!isNaN(i)) this._show(i);
          });
        });
        if (this.prevBtn) this.prevBtn.addEventListener('click', () => this._show(this.index - 1));
        if (this.nextBtn) this.nextBtn.addEventListener('click', () => this._show(this.index + 1));

        this._setupDrag();
        window.addEventListener('resize', () => {
          this.width = this.mainContainer.offsetWidth;
          // Reapply current index transform in case the width changed.
          this._renderRest();
        }, { passive: true });

        this._renderRest();
      }

      _setupDrag() {
        if (this.slides.length <= 1) return;
        const target = this.mainContainer;
        if (!target) return;

        this._drag = {
          startX: 0,
          startY: 0,
          delta: 0,
          active: false,   // committed to a horizontal drag
          locked: false,   // direction has been determined
          mouseDown: false // separate path for desktop mouse
        };

        // Touch events with passive: false on touchmove so we can
        // call preventDefault as soon as we determine the gesture is
        // horizontal. That stops the browser from page-scrolling
        // along with the swipe.
        target.addEventListener('touchstart', (e) => this._onTouchStart(e), { passive: true });
        target.addEventListener('touchmove',  (e) => this._onTouchMove(e),  { passive: false });
        target.addEventListener('touchend',   (e) => this._onTouchEnd(e),   { passive: true });
        target.addEventListener('touchcancel',(e) => this._onTouchEnd(e),   { passive: true });

        // Mouse drag for desktop testing / fallback.
        target.addEventListener('mousedown', (e) => this._onMouseDown(e));
      }

      _gap() {
        // CSS gap reads as a px string ("12px"); cache once we have it.
        if (this._gapPx == null) {
          const raw = getComputedStyle(this.track).columnGap || getComputedStyle(this.track).gap;
          this._gapPx = parseFloat(raw) || 0;
        }
        return this._gapPx;
      }

      _onTouchStart(e) {
        const t = e.touches[0];
        if (!t) return;
        const d = this._drag;
        d.startX = t.clientX;
        d.startY = t.clientY;
        d.delta = 0;
        d.active = false;
        d.locked = false;
        this.width = this.mainContainer.offsetWidth;
        this._gapPx = null; // recompute on each gesture in case settings changed
      }

      _onTouchMove(e) {
        const t = e.touches[0];
        if (!t) return;
        const d = this._drag;
        const dx = t.clientX - d.startX;
        const dy = t.clientY - d.startY;

        if (!d.locked) {
          // Commit direction at 5px movement. If horizontal-dominant,
          // we own the gesture for the rest of this touch. If vertical-
          // dominant, we leave it alone so the page scrolls.
          if (Math.abs(dx) > 5 || Math.abs(dy) > 5) {
            d.locked = true;
            d.active = Math.abs(dx) > Math.abs(dy);
            if (d.active) this.mainContainer.classList.add('is-dragging');
          } else {
            return;
          }
        }

        if (d.active) {
          e.preventDefault(); // block browser scroll for THIS gesture
          d.delta = dx;
          this._renderDrag();
        }
      }

      _onTouchEnd() {
        this._finishDrag();
      }

      // ---- Mouse drag (desktop) ----
      _onMouseDown(e) {
        if (e.button !== 0) return;
        const d = this._drag;
        d.mouseDown = true;
        d.startX = e.clientX;
        d.startY = e.clientY;
        d.delta = 0;
        d.active = false;
        d.locked = false;
        this.width = this.mainContainer.offsetWidth;
        this._gapPx = null;
        // Track mousemove + mouseup on document so the drag survives
        // even if the cursor leaves the image.
        this._mouseMoveHandler = (ev) => this._onMouseMove(ev);
        this._mouseUpHandler = (ev) => this._onMouseUp(ev);
        document.addEventListener('mousemove', this._mouseMoveHandler);
        document.addEventListener('mouseup', this._mouseUpHandler);
        e.preventDefault();
      }
      _onMouseMove(e) {
        const d = this._drag;
        if (!d.mouseDown) return;
        const dx = e.clientX - d.startX;
        const dy = e.clientY - d.startY;
        if (!d.locked) {
          if (Math.abs(dx) > 5 || Math.abs(dy) > 5) {
            d.locked = true;
            d.active = Math.abs(dx) > Math.abs(dy);
            if (d.active) this.mainContainer.classList.add('is-dragging');
          } else {
            return;
          }
        }
        if (d.active) {
          d.delta = dx;
          this._renderDrag();
        }
      }
      _onMouseUp() {
        const d = this._drag;
        if (!d.mouseDown) return;
        d.mouseDown = false;
        document.removeEventListener('mousemove', this._mouseMoveHandler);
        document.removeEventListener('mouseup', this._mouseUpHandler);
        this._finishDrag();
      }

      _finishDrag() {
        const d = this._drag;
        this.mainContainer.classList.remove('is-dragging');
        if (d.active) {
          const threshold = this.width * 0.15;
          let next = this.index;
          if (d.delta < -threshold) next = this.index + 1;
          else if (d.delta > threshold) next = this.index - 1;
          this._show(next);
        }
        d.active = false;
        d.locked = false;
        d.delta = 0;
      }

      _renderDrag() {
        if (!this.width) this.width = this.mainContainer.offsetWidth;
        const gap = this._gap();
        const offset = -this.index * (this.width + gap) + this._drag.delta;
        this.track.style.transform = `translateX(${offset}px)`;
      }

      _renderRest() {
        // translateX(calc(-N * 100% - N * gap)) — survives resize
        // because the 100% is relative to the track's width.
        const gap = this._gap();
        this.track.style.transform = `translateX(calc(${-this.index * 100}% - ${this.index * gap}px))`;
      }

      _show(i) {
        const count = this.slides.length;
        if (count === 0) return;
        const next = ((i % count) + count) % count;
        this.index = next;
        this._renderRest();

        this.thumbs.forEach((thumb, idx) => {
          thumb.classList.toggle('is-active', idx === next);
        });
        const activeThumb = this.thumbs[next];
        if (activeThumb && activeThumb.scrollIntoView) {
          activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        }
      }
    }
    customElements.define('custom-product-gallery', CustomProductGallery);
  }

  // ---------- Testimonial carousel ----------
  if (!customElements.get('custom-testimonial-carousel')) {
    class CustomTestimonialCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        if (!this.track) return;
        this.realSlides = Array.from(this.track.children);
        this.count = this.realSlides.length;
        if (this.count <= 1) return;

        // Clone first → end, last → start for a seamless infinite loop.
        const first = this.realSlides[0].cloneNode(true);
        const last = this.realSlides[this.count - 1].cloneNode(true);
        first.setAttribute('aria-hidden', 'true');
        last.setAttribute('aria-hidden', 'true');
        first.dataset.clone = 'head';
        last.dataset.clone = 'tail';
        this.track.appendChild(first);
        this.track.insertBefore(last, this.track.firstChild);
        this.allSlides = Array.from(this.track.children);
        this.index = 1; // start at the first real slide (tail clone is 0)

        this._drag = { startX: 0, startY: 0, delta: 0, active: false, locked: false, mouseDown: false };

        this.track.addEventListener('touchstart', (e) => this._onTouchStart(e), { passive: true });
        this.track.addEventListener('touchmove',  (e) => this._onTouchMove(e),  { passive: false });
        this.track.addEventListener('touchend',   (e) => this._onTouchEnd(e),   { passive: true });
        this.track.addEventListener('touchcancel',(e) => this._onTouchEnd(e),   { passive: true });
        this.track.addEventListener('mousedown',  (e) => this._onMouseDown(e));

        this.track.addEventListener('transitionend', () => this._maybeTeleport());
        window.addEventListener('resize', () => this._render(), { passive: true });

        requestAnimationFrame(() => this._render());
      }

      _slideStep() {
        const slide = this.allSlides[0];
        if (!slide) return 0;
        const style = getComputedStyle(this.track);
        const gap = parseFloat(style.columnGap || style.gap) || 0;
        return slide.offsetWidth + gap;
      }

      _render(withTransition = true) {
        const step = this._slideStep();
        if (!withTransition) {
          this.track.style.transition = 'none';
          this.track.style.transform = `translateX(${-this.index * step}px)`;
          /* eslint-disable-next-line no-unused-expressions */
          this.track.offsetHeight; // force reflow
          this.track.style.transition = '';
        } else {
          this.track.style.transform = `translateX(${-this.index * step}px)`;
        }
      }

      _renderDrag(delta) {
        const step = this._slideStep();
        this.track.style.transition = 'none';
        this.track.style.transform = `translateX(${-this.index * step + delta}px)`;
      }

      _show(nextIndex) {
        this.index = nextIndex;
        this.track.style.transition = '';
        this._render(true);
      }

      _maybeTeleport() {
        // tail clone (index 0)  → teleport to real last
        // head clone (last idx) → teleport to real first
        if (this.index === 0) {
          this.index = this.count;
          this._render(false);
        } else if (this.index === this.count + 1) {
          this.index = 1;
          this._render(false);
        }
      }

      _commit(delta) {
        const step = this._slideStep();
        const threshold = step * 0.15;
        let next = this.index;
        if (delta < -threshold) next = this.index + 1;
        else if (delta > threshold) next = this.index - 1;
        this._show(next);
      }

      _onTouchStart(e) {
        const t = e.touches[0]; if (!t) return;
        const d = this._drag;
        d.startX = t.clientX; d.startY = t.clientY;
        d.delta = 0; d.active = false; d.locked = false;
      }
      _onTouchMove(e) {
        const t = e.touches[0]; if (!t) return;
        const d = this._drag;
        const dx = t.clientX - d.startX;
        const dy = t.clientY - d.startY;
        if (!d.locked) {
          if (Math.abs(dx) > 5 || Math.abs(dy) > 5) {
            d.locked = true;
            d.active = Math.abs(dx) > Math.abs(dy);
            if (d.active) this.track.classList.add('is-dragging');
          } else return;
        }
        if (d.active) {
          e.preventDefault();
          d.delta = dx;
          this._renderDrag(dx);
        }
      }
      _onTouchEnd() {
        const d = this._drag;
        this.track.classList.remove('is-dragging');
        if (d.active) this._commit(d.delta);
        d.active = false; d.locked = false; d.delta = 0;
      }

      _onMouseDown(e) {
        if (e.button !== 0) return;
        const d = this._drag;
        d.mouseDown = true;
        d.startX = e.clientX; d.startY = e.clientY;
        d.delta = 0; d.active = false; d.locked = false;
        this._mouseMoveHandler = (ev) => this._onMouseMove(ev);
        this._mouseUpHandler = () => this._onMouseUp();
        document.addEventListener('mousemove', this._mouseMoveHandler);
        document.addEventListener('mouseup', this._mouseUpHandler);
        e.preventDefault();
      }
      _onMouseMove(e) {
        const d = this._drag;
        if (!d.mouseDown) return;
        const dx = e.clientX - d.startX;
        const dy = e.clientY - d.startY;
        if (!d.locked) {
          if (Math.abs(dx) > 5 || Math.abs(dy) > 5) {
            d.locked = true;
            d.active = Math.abs(dx) > Math.abs(dy);
            if (d.active) this.track.classList.add('is-dragging');
          } else return;
        }
        if (d.active) { d.delta = dx; this._renderDrag(dx); }
      }
      _onMouseUp() {
        const d = this._drag;
        if (!d.mouseDown) return;
        d.mouseDown = false;
        document.removeEventListener('mousemove', this._mouseMoveHandler);
        document.removeEventListener('mouseup', this._mouseUpHandler);
        this.track.classList.remove('is-dragging');
        if (d.active) this._commit(d.delta);
        d.active = false; d.locked = false; d.delta = 0;
      }
    }
    customElements.define('custom-testimonial-carousel', CustomTestimonialCarousel);
  }

  // ---------- Product form (variants, quantity, buy now) ----------
  function formatMoney(cents, format) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try { return window.Shopify.formatMoney(cents, format); } catch (_) {}
    }
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  function readJsonScript(form, selector) {
    const el = form.querySelector(selector);
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (_) { return null; }
  }

  function initProductForm(form) {
    const variants = readJsonScript(form, '[data-cfp-variants]') || [];
    const moneyFormat = readJsonScript(form, '[data-cfp-money-format]') || '';
    const variantInput = form.querySelector('[data-variant-id]');
    const priceCurrent = form.querySelector('[data-price-current]');
    const priceCompare = form.querySelector('[data-price-compare]');
    const priceWrap = form.querySelector('[data-price]');
    const optionSelects = Array.from(form.querySelectorAll('[data-variant-option]'));
    // CTA dynamic-content hooks (one CTA per form, but query inside the
    // whole section for safety).
    const section = form.closest('.custom-featured-product') || document;
    const ctaPrice = section.querySelector('[data-cfp-cta-price]');
    const ctaCompare = section.querySelector('[data-cfp-cta-cmp]');
    const ctaVariant = section.querySelector('[data-cfp-cta-variant]');
    const ctaQty = section.querySelector('[data-cfp-cta-qty]');

    const findVariant = () => {
      const values = optionSelects.map((s) => s.value);
      return variants.find((v) => v.options.every((opt, i) => opt === values[i]));
    };

    // Quantity input (declared up front so updateCtaPrice can read it).
    const qtyInput = form.querySelector('[data-qty]');
    const qtyMinus = form.querySelector('[data-qty-minus]');
    const qtyPlus = form.querySelector('[data-qty-plus]');

    // Track the currently selected variant so qty changes can recompute
    // the CTA price without needing to re-resolve the variant.
    let currentVariant = findVariant() || variants[0] || null;

    const getQty = () => {
      if (!qtyInput) return 1;
      return Math.max(1, parseInt(qtyInput.value, 10) || 1);
    };

    // Only the CTA price reflects qty. The main price block stays per-
    // unit (standard Shopify convention).
    const updateCtaPrice = () => {
      if (!currentVariant) return;
      const qty = getQty();
      if (ctaPrice) ctaPrice.textContent = formatMoney(currentVariant.price * qty, moneyFormat);
      if (ctaCompare) {
        if (currentVariant.compare_at_price && currentVariant.compare_at_price > currentVariant.price) {
          ctaCompare.textContent = formatMoney(currentVariant.compare_at_price * qty, moneyFormat);
          ctaCompare.removeAttribute('hidden');
        } else {
          ctaCompare.textContent = '';
          ctaCompare.setAttribute('hidden', '');
        }
      }
      if (ctaQty) ctaQty.textContent = String(qty);
    };

    const updateForVariant = (variant) => {
      if (!variant) return;
      currentVariant = variant;
      if (variantInput) variantInput.value = variant.id;
      if (priceCurrent) priceCurrent.textContent = formatMoney(variant.price, moneyFormat);
      if (priceCompare) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          priceCompare.textContent = formatMoney(variant.compare_at_price, moneyFormat);
          priceCompare.removeAttribute('hidden');
          if (priceWrap) priceWrap.classList.add('is-sale');
        } else {
          priceCompare.setAttribute('hidden', '');
          if (priceWrap) priceWrap.classList.remove('is-sale');
        }
      }
      if (ctaVariant) ctaVariant.textContent = variant.title || '';
      updateCtaPrice();
    };

    optionSelects.forEach((sel) => {
      sel.addEventListener('change', () => updateForVariant(findVariant()));
    });

    // Gifts: toggle is-locked on each gift card based on the qty
    // input and the per-gift unlock threshold (data-gift-unlock-at).
    const giftCards = Array.from(section.querySelectorAll('[data-gift-unlock-at]'));
    const updateGifts = () => {
      if (!giftCards.length) return;
      const qty = getQty();
      giftCards.forEach((card) => {
        const threshold = parseInt(card.dataset.giftUnlockAt, 10);
        if (!isFinite(threshold)) return;
        card.classList.toggle('is-locked', qty < threshold);
      });
    };

    if (qtyInput) {
      if (qtyMinus) qtyMinus.addEventListener('click', () => {
        qtyInput.value = Math.max(parseInt(qtyInput.min || '1', 10), (parseInt(qtyInput.value, 10) || 1) - 1);
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
      if (qtyPlus) qtyPlus.addEventListener('click', () => {
        qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
        qtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      });
      qtyInput.addEventListener('change', () => { updateCtaPrice(); updateGifts(); });
      qtyInput.addEventListener('input', () => { updateCtaPrice(); updateGifts(); });
      // Initial sync so the CTA + gifts reflect the saved/default qty + variant.
      updateCtaPrice();
    }
    // Run initial gift evaluation even if there's no qty input
    // (so qty 1 reveals the first gift at page load).
    updateGifts();

    // Buy now — intercept submit, add to cart via AJAX, then redirect.
    const buyNowBtn = form.querySelector('[data-action="buy_now"]');
    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', () => { form.dataset.submitAction = 'buy_now'; });
      form.addEventListener('submit', (e) => {
        if (form.dataset.submitAction !== 'buy_now') return;
        e.preventDefault();
        delete form.dataset.submitAction;
        const formData = new FormData(form);
        fetch('/cart/add.js', { method: 'POST', body: formData })
          .then((r) => r.ok ? r.json() : Promise.reject(r))
          .then(() => { window.location.href = '/checkout'; })
          .catch(() => { form.submit(); });
      });
    }
  }

  document.querySelectorAll('.cfp__form').forEach(initProductForm);

  // ---------- Modal ----------
  function openModal(id) {
    const modal = document.getElementById(id);
    if (!modal) return;
    if (typeof modal.showModal === 'function') {
      modal.showModal();
    } else {
      // Fallback for browsers without <dialog>: toggle a class
      modal.setAttribute('open', '');
    }
    document.body.style.overflow = 'hidden';
  }

  function closeModal(modal) {
    if (!modal) return;
    if (typeof modal.close === 'function') {
      modal.close();
    } else {
      modal.removeAttribute('open');
    }
    document.body.style.overflow = '';
  }

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-modal-open]');
    if (opener) {
      e.preventDefault();
      openModal(opener.getAttribute('data-modal-open'));
      return;
    }

    const closer = e.target.closest('[data-modal-close]');
    if (closer) {
      closeModal(closer.closest('dialog.cfp__modal'));
      return;
    }

    // Click on the backdrop (i.e. directly on the dialog itself, not its inner)
    const dialog = e.target.closest('dialog.cfp__modal');
    if (dialog && e.target === dialog) {
      closeModal(dialog);
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      document.querySelectorAll('dialog.cfp__modal[open]').forEach((d) => {
        closeModal(d);
      });
    }
  });

  // -------------------- Tabs (custom element) --------------------
  // Click a tab → mark it active, mark the matching panel active,
  // clear .is-active from siblings. Scoped to the element instance.
  class CustomCfpTabs extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.activate(tab));
      });
    }
    activate(tab) {
      const target = tab.dataset.tabTarget;
      this.tabs.forEach((t) => {
        const on = t === tab;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      this.panels.forEach((p) => {
        p.classList.toggle('is-active', p.id === target);
      });
    }
  }
  if (!customElements.get('custom-cfp-tabs')) {
    customElements.define('custom-cfp-tabs', CustomCfpTabs);
  }

  // ------ Collapsible rows: single-open mode ------
  // Native <details> handles open/close. When data-cr-mode="single"
  // on the wrapper, opening one row closes any sibling that was open.
  document.addEventListener('toggle', (e) => {
    const row = e.target.closest('.cfp__cr-row');
    if (!row || !row.open) return;
    const wrap = row.closest('.cfp__cr[data-cr-mode="single"]');
    if (!wrap) return;
    wrap.querySelectorAll('.cfp__cr-row[open]').forEach((other) => {
      if (other !== row) other.open = false;
    });
  }, true);
})();
